module.exports = __webpack_public_path__ + "static/media/qr-code-icon.db192d99.svg";